import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { isStaff } from '../../../../helpers/global';
import RushCheckbox from '../RushCheckbox';
import AssignedProcessorsMultiSelect from '../../../AssignedProcessors';
import HoaForm from '../../../hoaForm/HoaForm';
import ClientHoaTextForm from '../../../hoaForm/ClientHoaTextForm';
import { blankHoaSnapshot } from '../../../HoaDirectory/HoaDirectoryHelper';

let InitialFormFieldError = [
  { key: 'status', isNotValid: false, type: 'string' },
  { key: 'assignedProcessors', isNotValid: false, type: 'array' },
  {
    key: 'homeOwnerInformation',
    type: [
      {
        objectType: [
          { key: 'name', isNotValid: false, type: 'string' },
          { key: 'email', isNotValid: false, type: 'email' }
        ]
      }
    ]
  }
];

// update the field of the form Field error
const updateOnChangeErrorField = (fieldError = [], key, index, subKey) => {
  return fieldError.map(field => {
    if (field.key === key) {
      if (key === 'homeOwnerInformation') {
        let fieldType = [...field.type];
        fieldType[index] = {
          objectType: fieldType[index].objectType.map(o => {
            if (o.key === subKey) {
              return { ...o, isNotValid: false };
            }
            return o;
          })
        };
        return {
          key,
          type: [...fieldType]
        };
      }
      return { key, isNotValid: false, type: field.type };
    } else {
      return field;
    }
  });
};

export const Estoppel = ({ defaultValues, errors, numberOfHOA, setNumberOfHOA, role, formData, setFormData }) => {
  const staff = isStaff(role);
  const [formFieldError, setFormFieldError] = useState(
    staff
      ? [...InitialFormFieldError]
      : [...InitialFormFieldError].filter(v => v.key !== 'status' && v.key !== 'assignedProcessors')
  );

  useEffect(() => {
    if (Object.keys(defaultValues).length > 0) {
      setFormData(defaultValues);
      setNumberOfHOA(numberOfHOA);
    }
  }, [defaultValues]);

  const handleRushChange = () => {
    setFormData(prevData => ({
      ...prevData,
      rush: !prevData?.rush
    }));
  };

  const handleAssignedProcessorsChange = e => {
    const assignedProcessorIds = e.map(a => a._id);
    setFormData(prevData => ({ ...prevData, assignedProcessors: assignedProcessorIds }));
    setFormFieldError(updateOnChangeErrorField(formFieldError, 'assignedProcessors'));
  };

  return (
    <>
      <p className="col-title my-2">Estoppel Details</p>
      <Row className="align-items-center">
        {staff && (
          <Col md={3}>
            <Form.Group className="midFont">
              <Form.Label>
                Assigned Processors<span className="text-danger">*</span>
              </Form.Label>
              <AssignedProcessorsMultiSelect
                id="estoppelAssignedProcessors"
                error={errors.estoppelAssignedProcessors}
                onChange={handleAssignedProcessorsChange}
                selectedProcessorsID={formData.assignedProcessors}
              />
              {errors.estoppelAssignedProcessors && (
                <p className="xsmallFont text-rush">{errors.estoppelAssignedProcessors}</p>
              )}
            </Form.Group>
          </Col>
        )}

        <Col md={3}>
          <RushCheckbox
            serviceName={'Estoppel'}
            serviceKey={'estoppel'}
            checked={formData?.rush}
            onCheckedChange={handleRushChange}
          />
        </Col>
      </Row>

      <div className="mt-3">
        {staff ? (
          <HoaForm
            value={formData?.homeOwnerInformation || [blankHoaSnapshot()]}
            showAddLater
            twoColumnLayout
            onChange={homeOwnerInformation => {
              setFormData({ ...formData, homeOwnerInformation });
              setNumberOfHOA(homeOwnerInformation.length);
            }}
            errors={errors}
          />
        ) : (
          <ClientHoaTextForm
            value={formData?.homeOwnerInformation || [blankHoaSnapshot()]}
            twoColumnLayout
            onChange={homeOwnerInformation => {
              setFormData({ ...formData, homeOwnerInformation });
              setNumberOfHOA(homeOwnerInformation.length);
            }}
            errors={errors}
          />
        )}
      </div>
    </>
  );
};
